<div (mouseleave)="onMouseLeaveBox()">
  <div *ngIf="isvisbut"  class="top-bottons-container" [style.left.px]="buttMenuLeft" [style.top.px]="buttMenuTop - 33">
    <button mat-mini-fab class="top-bottons" (mousedown)="centerClick()" [matTooltip]="'CONSTS.CENTER'| translate" matTooltipPosition='above'>
      <mat-icon class="icon-button" style="vertical-align: unset;">room</mat-icon>
    </button>
    <button mat-mini-fab class="top-bottons" (mousedown)="createTrackClick()" [matTooltip]="'CONSTS.CREATE_CAMERA'| translate"
      matTooltipPosition='above'>
      <mat-icon class="icon-button" style="vertical-align: unset;">add</mat-icon>
    </button>
  </div>
  <div #obj id="obj" *ngIf="isvisobj" class="menu-style" [style.left.px]="objectsMenuLeft"
    [style.top.px]="objectsMenuTop">
    <button fxLayout="row" class="button-style" mat-menu-item *ngFor="let menuTitle of objects"
      (mouseenter)="onObjectsMenuClick(menuTitle, $event)" 
      (dblclick)="onObjectsMenuDblClick(menuTitle, $event)">
      <div class="sensor-image" [style.background-color]="menuTitle.getCssColor()"
        [style.-webkit-mask-image]="menuTitle.getSvgSymbol()"></div>
      <div>{{menuTitle.getTitle()}}</div>
    </button>
  </div>
  <div #con id="con" *ngIf="isviscon" class="menu-style" [style.left.px]="contextMenuLeft"
    [style.top.px]="contextMenuTop">
    <button class="button-style" mat-menu-item *ngFor="let menuTitle of contextMenuTitles"
      (mousedown)="onContextMenuClick(menuTitle, $event)">{{menuTitle}}</button>
    <mat-divider *ngIf="contextMenuTitles.length && globalMenuTitles.length"></mat-divider>
    <button class="button-style" mat-menu-item *ngFor="let menuTitle of globalMenuTitles"
      (mousedown)="onContextMenuClick(menuTitle, $event)">{{menuTitle}}</button>
  </div>
</div>